import {
	fileUpload,
	basicMenu,
	calendarReminderMenu,
	clientOverviewMailMenu,
	mailMenu
} from './rich_text_tokens';

textAngularConfig.$inject = [
	'emailSettingsDataService',
	'taRegisterTool',
	'$delegate',
	'messageService'
];

export function textAngularConfig(
	emailSettingsDataService,
	taRegisterTool,
	taOptions,
	messageService
) {
	function getOffset(el) {
		let _x = 0;
		let _y = 0;
		while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
			_x += el.offsetLeft - el.scrollLeft;
			_y += el.offsetTop - el.scrollTop;
			el = el.offsetParent;
		}
		return { top: _y, left: _x };
	}

	function _getTipPosition(elem) {
		let el,
			x,
			y,
			elP,
			xP,
			yP,
			positionStyle = {};

		el = $(elem)[0];
		x = getOffset(el).left;
		y = getOffset(el).top;

		elP = $(elem).parents('.textarea-quad');
		xP = getOffset(elP[0]).left;
		yP = getOffset(elP[0]).top;

		positionStyle.left = `${x - xP}px`;
		positionStyle.top = `${y - yP}px`;

		return positionStyle;
	}

	taOptions.toolbar = [
		['bold', 'italics', 'underline'],
		['link'],
		['ul', 'ol'],
		['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull']
	];

	taOptions.keyMappings = [];

	taRegisterTool('link', {
		display:
			'<button type="button" class="btn btn-default btn-link-edit" name="attachment_fiels" tabindex="-1" on-click="executeAction($event)" ng-class="displayActiveToolClass(active)" title="Insert link" unselectable="on" disabled="disabled"><i class="fa fa-link"></i></button>',
		action() {
			const selectedText = `${window.getSelection()}`;
			$('.linkEdited').removeClass('linkEdited');

			const glossTag = `<span></span><a class="linkEdited">${selectedText}</a><span></span>`;
			this.$editor().wrapSelection('insertHTML', glossTag, true);

			delete this.$parent.$parent.link2edit.url;
			delete this.$parent.$parent.link2edit.linkTo;
			this.$parent.$parent.link2edit.select = '';
			this.$parent.$parent.link2edit.select = '.linkEdited';

			return false;
		},
		activeState(commonElement) {
			const tipEl = $('.focussed + .editLinkTips');
			tipEl.hide();

			$('.ta-editor .linkEdited').removeClass('linkEdited');

			$('.focussed .btn-link-edit').prop('disabled', false);
			$('.focussed .insert-var-container .dropdown-toggle').prop(
				'disabled',
				false
			);

			if (commonElement) {
				this.$parent.$parent.link2edit.url = '';
				this.$parent.$parent.link2edit.linkTo = '';
				if (commonElement[0].tagName === 'A') {
					$('.focussed .btn-link-edit').prop('disabled', true);
					$('.focussed .insert-var-container .dropdown-toggle').prop(
						'disabled',
						true
					);

					if (commonElement[0].classList.contains('linkEdited')) {
						tipEl.css(_getTipPosition(commonElement));
						tipEl.show();
					} else {
						commonElement[0].classList.add('linkEdited');
						tipEl.css(_getTipPosition(commonElement));
						tipEl.show();
					}

					return false;
				}
			}
		}
	});

	taRegisterTool('attachFilesFromComputer', {
		display:
			'<button type="button" class="btn btn-default btn-attach-fiels" name="attachment_fiels" tabindex="-1" on-click="executeAction($event)" ng-class="displayActiveToolClass(active)" title="Attachment files" unselectable="on" disabled="disabled"><i class="fa fa-paperclip"></i></button>',
		action() {
			this.$element
				.parents('.sn-ta-editor')
				.find('input.attachments__input')
				.click();
		}
	});

	taRegisterTool('attachFiles', {
		display: fileUpload.menu,
		disabled() {
			this.focusHack = function() {
				$('.ta-scroll-window [contenteditable]')[0].focus();
			};
			this.insertVariable = fileUpload.methods;
			this.showFilesModal = function() {
				this.$element
					.parents('.sn-ta-editor')
					.find('input')
					.focus(function() {
						this.blur();
					});
				this.$element
					.parents('.sn-ta-editor')
					.find('#filesModal')
					.modal('show');
				$('.ta-scroll-window [contenteditable]')[0].blur();
			};
			this.uploadFromComputer = function() {
				this.$element
					.parents('.sn-ta-editor')
					.find('input.attachments__input')
					.click();
			};
			this.show = true;
			this.isDisabled = function() {
				return false;
			};
		},
		action(e) {
			const uploadedFiles = this.$root.uploadedFiles;
			if (typeof uploadedFiles !== 'undefined' && uploadedFiles === 0) {
				$('a.showfiles')
					.attr('disabled', true)
					.css('opacity', '0.5');
			} else {
				$('a.showfiles')
					.attr('disabled', false)
					.css('opacity', '1');
			}
		}
	});

	taRegisterTool('reminderTokens', {
		display: basicMenu.menu,
		disabled() {
			this.focusHack = function() {
				$('.ta-scroll-window [contenteditable]')[0].focus();
			};
			this.insertVariable = basicMenu.methods;
			this.show = true;
			this.isDisabled = function() {
				return false;
			};
		},
		action() {}
	});

	taRegisterTool('mailTokens', {
		display: mailMenu.menu,
		disabled() {
			this.focusHack = function() {
				$('.ta-scroll-window [contenteditable]')[0].focus();
			};
			this.insertVariable = mailMenu.methods;
			this.show = true;
			this.isDisabled = function() {
				return false;
			};
		},
		action() {}
	});

	taRegisterTool('calendarReminderTokens', {
		display: calendarReminderMenu.menu,
		disabled() {
			this.focusHack = function() {
				$('.ta-scroll-window [contenteditable]')[0].focus();
			};
			this.insertVariable = calendarReminderMenu.methods;
			this.show = true;
			this.isDisabled = function() {
				return false;
			};
		},
		action() {}
	});

	taRegisterTool('clientOverviewMailToken', {
		display: clientOverviewMailMenu.menu,
		disabled() {
			this.focusHack = function() {
				$('.ta-scroll-window [contenteditable]')[0].focus();
			};
			this.insertVariable = clientOverviewMailMenu.methods;
			this.show = true;
			this.isDisabled = function() {
				return false;
			};
		},
		action() {}
	});

	taRegisterTool('loadImage', {
		iconclass: 'fa fa-file-image-o',
		buttontext: 'Upload image',
		action() {
			let cntrlIsPressed = false;

			const initInjector = angular.injector(['ng']);
			const $http = initInjector.get('$http');

			if (!$http.defaults.headers.get) {
				$http.defaults.headers.get = {};
			}

			// disable IE ajax request caching
			$http.defaults.headers.get['If-Modified-Since'] =
				'Mon, 26 Jul 1997 05:00:00 GMT';
			$http.defaults.headers.get['Cache-Control'] = 'no-cache';
			$http.defaults.headers.get.Pragma = 'no-cache';

			const textAngular = this;
			const savedSelection = rangy.saveSelection();
			rangy.restoreSelection(savedSelection);

			const removeAllImages = () => $('.signayureImg').remove();

			const companyImageError = () => {
				toastr.error(
					'Please make sure you upload a valid .JPG or .PNG file into the email signature.',
					"Something's not right here!"
				);
			};
			const companyImageSizeError = () => {
				toastr.error("The file you're attaching is bigger than the 2 Mb.");
			};
			const serverError = () => {
				toastr.error('Failed request to server');
			};

			function saveNewImgOnServer(dataToSave) {
				emailSettingsDataService.setOnLoadImageSuccess(true);
				emailSettingsDataService.saveImage(dataToSave).subscribe(
					result => {
						if (result.errorMessage === 'Unsupported Image Type!') {
							companyImageError();
							return;
						}
						getSettings();
						emailSettingsDataService.setOnLoadImageSuccess(false);
						messageService.showToaster('s_4', 'emailSettings');
					},
					() => serverError()
				);
			}

			const insertImg = function(imgSrc) {
				const insertImgUrl = `${imgSrc}?${new Date().getTime()}`;
				const signatureImgClassId = `signayureImg__${Math.random()
					.toString(36)
					.substr(2, 9)}`;

				const myImage = new Image();
				myImage.src = insertImgUrl;
				myImage.onload = function() {
					const signayureImgDOM = document.querySelector(
						`.${signatureImgClassId}`
					);
					signayureImgDOM.height = myImage.naturalHeight;
					signayureImgDOM.width = myImage.naturalWidth;
					signayureImgDOM.style.height = myImage.naturalHeight;
					signayureImgDOM.style.width = myImage.naturalWidth;

					signayureImgDOM.classList.remove('hide');
				};
				const htmlText = `<span><img id='signatureImg' class='signayureImg hide ${signatureImgClassId}' src='${insertImgUrl}'/></span>`;

				return textAngular
					.$editor()
					.wrapSelection('insertHTML', htmlText, true);
			};

			$(document).keydown(event => {
				if (event.which === '17') cntrlIsPressed = true;
			});

			$(document).keyup(() => {
				cntrlIsPressed = false;
			});

			const uploadNewImage = function() {
				const inputHtml =
					'<input id="signatureInput" type="file" accept="image/*" style="display:none" />';

				$(document.body).append(inputHtml);

				const element = $('#signatureInput');

				element.on('change', function() {
					let file = this.files[0];

					const MAX_SIZE = 2000; // 2MB MAX file size
					const usingFormat = ['image/png', 'image/jpg', 'image/jpeg'];

					if (file.size > MAX_SIZE * 1024) {
						file = null;
						return companyImageSizeError();
					}

					if (usingFormat.indexOf(file.type) < 0) {
						file = null;
						return companyImageError();
					}

					if (file) {
						const formData = new FormData();
						formData.append('file', file);
						saveNewImgOnServer(formData);
					}
				});

				element.trigger('click');
			};

			function getSettings() {
				emailSettingsDataService.getEmailSettings().subscribe(
					result => {
						removeAllImages();
						insertImg(result.imageUrl);
					},
					() => serverError()
				);
			}

			return uploadNewImage();
		}
	});

	return taOptions;
}



// WEBPACK FOOTER //
// ./web/js/helper/textAngular.config.js